import moment from 'moment';
import { useState } from 'react';
import Switch from "react-switch";
import useClickOutside from '../../../../useClickOutside';

export const ColumnWarehouses = (translate, warning, handleEdit, editStatus, langLocal, detailsOfWarehouse, productsByWarehouse) => {
    const [options, setOptions] = useState(false)
    const [row_id, setRowId] = useState(null)
    let domNode = useClickOutside(() => {
        setOptions(false);
        setRowId(null)
    });
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('name')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['name']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('city')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['city']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('country')}</span>,
            cell: (row) => (
                <span>{row['country']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('phone')}</span>,
            cell: (row) => (
                <span>{row['phone_number']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('created_at')}</span>,
            cell: (row) => (
                <span>{moment(row['created_at']).format("YYYY-MM-DD")}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('activation')}</span>,
            cell: (row) => (
                <div className='div_switch'>
                    <SwitchComponent checked={row.status} /*onChange={() => editStatus(row.id, row.status)}*/ />
                </div>
            )
        },
        {
            name: <span className="color_spann">{translate('actions')}</span>,
            cell: (row, index) => (
                <div  >
                    {/*<i className='fa fa-edit icon_edit' onClick={(e) => handleEdit(e, row)} ></i>
                    <i className='fa fa-trash icon_trash' onClick={() => warning(row)} ></i>*/}
                    <i className='fa fa-ellipsis-v icon_edit' onClick={() => { setOptions(!options); setRowId(index) }}  ></i>
                    {
                        options && index === row_id && (
                            <div ref={domNode} className={`div-actions shadow_main`} style={langLocal === 'ar' ? { left: '20px' } : { left: '-100px' }} >
                                <span onClick={(e) => handleEdit(e, row)} >{translate('edit')}</span>
                                <span onClick={() => warning(row)} >{translate('delete')}</span>
                                <span onClick={() => detailsOfWarehouse(row?.id)} >{translate('details')}</span>
                                <span /*onClick={() => productsByWarehouse(row?.id,row?.name)}*/ >{translate('materials')}</span>
                                <span>{translate('orders')}</span>
                            </div>
                        )
                    }
                </div>
            )
        }
    ]
    return {
        columns
    }
}
function SwitchComponent({ checked, onChange }) {
    return (
        <Switch
            onColor='#756bc1'
            checkedIcon={false}
            uncheckedIcon={false}
            height={20}
            width={40}
            handleDiameter={15}
            checked={checked}
            onChange={onChange}
        />
    );
}